import { fetchCountrySummary, search } from '@/api';
import { KButton, KInput } from '@/components';

// helpers
import dummyDatabase from '@/utils/dummy-database';
import stringHelpers from '@/utils/string-helpers';
import scrollToTop from '@/utils/scrollToTop';
import { updateClicked } from '@/api/dataset';
import searchSuggestions from '@/utils/searchSuggestions';
import Footer from '@/components/Footer/Footer.vue';
import { queryDataset } from '../../../api/search';

export default {
  name: 'Results',
  components: {
    KButton,
    KInput,
    Footer,
  },
  data: () => ({
    database: dummyDatabase,
    value: '',
    newSearch: '',
    relatedResults: [],
    relevantResults: [],
    relatedSearches: [],
    isSearching: false,
    suggestions: [],
    searchId: '',
    loading: false,
    formLoading: false,
    dashboard: {},
    relatedQuerySearches: [],
  }),
  mounted() {
    this.setValue();
    // this.mockFetch();
    this.fetchResults();
  },
  watch: {
    $route(val) {
      this.search(decodeURIComponent(val.query.q));
    },
    value(val) {
      searchSuggestions.call(this, val);
    },
  },
  computed: {
    sortedSuggestions() {
      const suggestions = this.suggestions.map((s) => s.searchTerm);

      return suggestions.slice(0, 5);
    },

    // get search result from store
    searchResults() {
      return this.$store.getters['search/lastSearchResults'];
    },
    searchTerm() {
      return decodeURIComponent(this.$route.query.q || '');
    },
    isLoading() {
      return this.$store.getters['search/isLoading'] || this.localLoading;
    },
  },
  async created() {
    // On component creation (including page refresh), check if we need to refetch
    const storeTerm = this.$store.state.search.lastSearchTerm;
    const storeResult = this.$store.state.search.lastSearchResults;
    if (storeResult && storeTerm === this.searchTerm) {
      this.relatedQuerySearches = storeResult.related_search;
      this.getCountryDashboard(storeResult.country.toLowerCase());
    }

    if (!this.searchResults || storeTerm !== this.searchTerm) {
      await this.fetchQueryResults();
    }
  },
  methods: {
    ...stringHelpers,
    // async fetchResults() {
    //   try {
    //     this.suggestions = [];
    //     // this.loading = true;
    //     const response = await search({ q: this.value });
    //     const { data } = response;
    //     if (data.error) throw Error(data.error);
    //     const {
    //       relatedResults,
    //       relevantResults,
    //       relatedSearches: related,
    //     } = data.data.searchResult;
    //     // if (this.$refs.searchBtn) this.$refs.searchBtn.focus();
    //     this.searchId = data.data.searchId;
    //     this.relatedResults = this.getUniqueResult(relatedResults);
    //     this.relevantResults = this.getUniqueResult(relevantResults);
    //     const relatedKeywords = {};
    //     related.forEach(({ searchTerm }) => {
    //       relatedKeywords[searchTerm] = (relatedKeywords[searchTerm] || 0) + 1;
    //     });
    //     this.relatedSearches = Object.entries(relatedKeywords)
    //       .sort((a, b) => b[1] - a[1])
    //       .slice(0, 10);

    //     // const noRelevant = !this.relevantResults.length;
    //     // const noRelated = !this.relatedResults.length;

    //     // // fetch country dashboard if exists
    //     // let country;
    //     // if (!noRelevant) {
    //     //   country = this.relevantResults[0].country;
    //     // } else if (!noRelated) {
    //     //   country = this.relatedResults[0].country;
    //     // } else {
    //     //   country = '';
    //     // }

    //     // if (country) {
    //     //   const summaryRes = await fetchCountrySummary({ country });
    //     //   if (summaryRes.data.data.length) {
    //     //     const [dashboard] = summaryRes.data.data;
    //     //     this.dashboard = dashboard;
    //     //   } else {
    //     //     this.dashboard = {};
    //     //   }
    //     // } else {
    //     //   this.dashboard = {};
    //     // }
    //   } catch (e) {
    //     console.log(e.response?.data.message || 'Something unexpected occurred on the server');
    //     this.$toast.show({
    //       message: 'Something unexpected occurred on the server',
    //     });
    //   } finally {
    //     // this.loading = false;
    //     scrollToTop();
    //   }
    // },
    async listenForClicks() {
      const { searchId } = this;
      try {
        const response = await updateClicked({ searchId, body: { clicked: 'TRUE' } });
        if (response.status !== 200) {
          throw Error(response.error);
        }
      } catch (error) {
        console.log(error);
      }
    },
    setValue() {
      this.value = decodeURIComponent(this.$route.query.q);
    },
    datasetId(res) {
      return res.datasetId || res.dataset_id;
    },
    getUniqueResult(results) {
      const uniqueResults = results.reduce((total, cur) => {
        const newTotal = { ...total };
        newTotal[cur.datasetId || cur.dataset_id] = cur;
        return newTotal;
      }, {});
      return Object.values(uniqueResults);
    },
    search(searchValue = null) {
      if (searchValue) this.value = searchValue;
      const { $route, $router, value } = this;

      if (value && value.trim()) {
        this.fetchResults();
        // this.fetchQueryResults();
      }
      // if value is not equal query value, then change
      if (decodeURIComponent($route.query.q) !== this.value) {
        const query = { query: { q: encodeURIComponent(value.trim()) } };
        if (this.value) {
          this.$router.push({ ...$router, ...query });
        }
      }
    },
    async fetchQueryResults(query = this.searchTerm) {
      this.loading = true;
      console.log(query);

      try {
        const response = await this.$store.dispatch('search/search', this.searchTerm);

        if (response.is_data) {
          const r = response.related_search[0];
          const path = `/indicators/${encodeURIComponent(r.search)}/${encodeURIComponent(
            r.metadata.country
          )}`;
          const query = {
            category: r.metadata.category,
            frequency: r.metadata.frequency,
            chartType: 'line',
            colour: '#23900F7B',
            startYear: r.metadata.min_date,
            endYear: r.metadata.max_date,
            country: r.metadata.country,
            indicator: r.metadata.indicator,
          };

          this.$router.push({ path, query });
        }

        this.relatedQuerySearches = response.related_search;

        // fetch country dashboard if exists
        const country = response.country.toLowerCase();

        if (country) {
          this.getCountryDashboard(country);
        } else {
          this.dashboard = {};
        }
        this.loading = false;
      
      } catch (error) {
        this.$toast.show({
          message: 'Something unexpected occurred on the server',
        });
      } finally {
        this.loading = false;
      }
    },

    async onSubmit () {
      this.formLoading = true;
      try {
        const response = await this.$store.dispatch('search/search', this.newSearch);

        if (response.is_data) {
          const r = response.related_search[0];
          const path = `/indicators/${encodeURIComponent(r.search)}/${encodeURIComponent(
            r.metadata.country
          )}`;
          const query = {
            category: r.metadata.category,
            frequency: r.metadata.frequency,
            chartType: 'line',
            colour: '#23900F7B',
            startYear: r.metadata.min_date,
            endYear: r.metadata.max_date,
            country: r.metadata.country,
            indicator: r.metadata.indicator,
          };

          this.$router.push({ path, query });
        }

        this.relatedQuerySearches = response.related_search;

        // fetch country dashboard if exists
        const country = response.country.toLowerCase();

        if (country) {
          this.getCountryDashboard(country);
        } else {
          this.dashboard = {};
        }
        this.formLoading = false;
      
      } catch (error) {
        this.$toast.show({
          message: 'Something unexpected occurred on the server',
        });
      } finally {
        this.formLoading = false;
      }
    },

    async getCountryDashboard(country) {
      const summaryRes = await fetchCountrySummary({ country });
      console.log(summaryRes);

      if (summaryRes.data.data.length) {
        const [dashboard] = summaryRes.data.data;
        this.dashboard = dashboard;
      } else {
        this.dashboard = {};
      }
    },
  },
};
